export default __webpack_public_path__ + "static/media/athena-logo3.b4abb103.png";